type SocialNameClient = {
  socialName?: string | null;
  allowsSocialName?: boolean;
};

export function shouldShowSocialName(
  client?: SocialNameClient | null
): boolean {
  if (client?.socialName?.trim()) {
    return true;
  }

  if (client?.allowsSocialName) {
    return true;
  }

  return false;
}

export function getClientDisplayName(
  client?: (SocialNameClient & { name?: string }) | null
): string {
  const socialName = client?.socialName?.trim();
  if (socialName) {
    return socialName;
  }

  return client?.name?.trim() || "";
}
